import { makeStyles, Switch } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import React, { useEffect, useState } from 'react';

export enum SwitchSize {
  'small' = 0,
  'medium' = 1,
}

interface Props {
  fieldName: string;
  onChange: (value: boolean) => void;
  formControlClassName?: string;
  size?: SwitchSize;
  checked?: boolean;
}

const InputSwitch: React.FC<Props> = ({
  fieldName,
  onChange,
  formControlClassName,
  checked = false,
  size = SwitchSize.medium,
}) => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(checked);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    let mounted = true;

    if (mounted && isChecked !== checked) {
      setIsChecked(checked);
    }

    return () => {
      mounted = false;
    };
  }, [checked, isChecked]);

  return (
    <FormControl
      className={formControlClassName ? `${formControlClassName} form-control` : 'form-control'}
    >
      <Switch
        checked={isChecked}
        onChange={handleChange}
        color="primary"
        name={fieldName}
        className={size === SwitchSize.small ? classes.small : ''}
      />
    </FormControl>
  );
};

const useStyles = makeStyles(() => ({
  small: {
    height: '33px',
    width: '48px',
    '& .MuiSwitch-thumb': {
      height: '14px',
      width: '14px',
    },
  },
}));

export default InputSwitch;
